import { Checkbox, Conditional, Select } from "@result/rui/components";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useBreedingValuesKodaIzracunQuery } from "#/pages/breeding-values/useBreedingValuesKodaIzracunQuery";
import * as species from "#/utils/SpeciesScope";

const KodaIzracunSelect = ({
  formField,
  labelType = "floating",
  selectionMode = "multiple",
  selectNewest = false,
  isRequired = false,
  label,
}) => {
  const { t } = useTranslation();

  const kodaIzracunQuery = useBreedingValuesKodaIzracunQuery();
  const supportedSpecies = species.get();

  useEffect(() => {
    if (kodaIzracunQuery.result?.list == null && supportedSpecies.length > 0) {
      kodaIzracunQuery.query({ supportedSpecies: supportedSpecies });
    }
  }, [kodaIzracunQuery, supportedSpecies]);

  useEffect(() => {
    const kodeIzracun = kodaIzracunQuery.result?.list;
    if (selectNewest && kodeIzracun?.length > 0) {
      formField.setValue(kodeIzracun[0]);
    }
  }, [kodaIzracunQuery.result?.list?.length]);

  return (
    <div>
      <Select
        options={kodaIzracunQuery.result?.list ?? []}
        selectionMode={selectionMode}
        formField={formField}
        label={label ?? t("breedingValues.catalogVersion")}
        labelType={labelType}
        isRequired={isRequired}
        className="mb-1"
      />
      <Conditional condition={selectionMode === "multiple"}>
        <Checkbox
          label={t("breedingValues.selectOrDeselectAll")}
          onChange={(isChecked) => {
            if (isChecked) {
              formField.setValue(kodaIzracunQuery.result?.list ?? []);
            } else {
              formField.setValue([]);
            }
          }}
        />
      </Conditional>
    </div>
  );
};

export default KodaIzracunSelect;
